<template>
  <div class="flex-1 overflow-y-auto py-2 pt-3 px-3" v-chat-scroll>
    <div v-for="(message, index) in messages" v-bind:class="'bubble ' + message.type" :key="index">
      <div v-if="isActiveChat && message.user && message.user.type === 'doctor'" >
        <div class="flex flex-no-grow flex-no-shrink justify-end mb-2">
          <div class="rounded-lg rounded-br-none bg-blue-lightest shadow-sm" style="max-width: 500px; word-wrap: break-word">
            <lab-test-card v-if="message.intentName === 'recommended_tests'" :data="message.payload"/>
            <drug-prescription-card v-if="message.intentName === 'file_prescription'" :data="message.payload"/>
            <div v-if="message.intentName === 'file_attachment'" class="py-2 pt-3 px-3" v-bind:class="{opaque: !messageStatus(message)}">
              <div class="flex flex-row self-end flex-no-shrink flex-no-grow">
                <div v-if="message.state === 'uploading'" class="flex flex-row">
                  <div class="relative flex flex-col justify-center items-center">
                      <svg class="progress-ring" width="48" height="48" style="z-index:1">
                          <circle :stroke-dasharray="dasharray()" :stroke-dashoffset="dashoffset(message.progress)" class="progress-ring-circle" stroke="green" stroke-width="3" fill="transparent" r="17" cx="24" cy="24" stroke-linecap="round"/>
                      </svg>
                      <svg width="48" height="48" style="z-index:0; position: absolute" >
                          <circle width="48" height="48" stroke="white" stroke-width="3" fill="transparent" r="17" cx="24" cy="24"/>
                      </svg>
                      <!-- <div class="w-6 h-6 cursor-pointer" style="position: absolute; z-index: 2"><img src="../assets/close.png"></div> -->
                  </div>
                  <div class="flex flex-col self-center">
                      <div class="text-xs mx-2 font-semibold text-green-dark" style="margin-bottom: 2px;">Uploading... {{message.progress}} %</div>
                      <div class="text-xs mx-2 text-grey-darkest">{{message.payload.file_name}} </div>
                  </div>
                </div>

                <!--Card 20 (Preparing) Uploding File-->
                <div v-else-if="message.state === 'preparing'" class="flex flex-row">
                  <div class="flex flex-col justify-center items-center">
                      <svg class="flex flex-col w-12 h-12 self-center">
                          <g fill="none" fill-rule="evenodd">
                              <g transform="translate(5 6)" stroke-width="3">
                              <circle stroke-opacity="" cx="18" cy="18" r="18" stroke="white"/>
                              <path d="M36 18c0-9.94-8.06-18-18-18" stroke-linecap="round" stroke="blue">
                              <animateTransform
                                  attributeName="transform"
                                  type="rotate"
                                  from="0 18 18"
                                  to="360 18 18"
                                  dur="1s"
                                  repeatCount="indefinite"/>
                              </path>
                              </g>
                          </g>
                      </svg>
                      <div class="w-6 h-6 cursor-pointer self-center" style="position: absolute; z-index: 2"><img src="../../assets/close.png"></div>
                  </div>
                  <div class="flex flex-col self-center">
                      <div class="text-xs mx-2 font-semibold text-grey-darker" style="color: blue; margin-bottom: 2px;">Preparing Upload</div>
                      <div class="text-xs mx-2 text-grey-darkest">{{message.payload.file_name}}</div>
                  </div>
                </div>

                <!--Card 21 (Retry Upload) Upload Failed-->
                <div v-else-if="message.state === 'reload'" class="h-auto flex flex-row self-end rounded-lg rounded-br-none">
                  <div class="flex flex-col justify-center items-center">
                      <div class="h-12 flex flex-col justify-center px-1 cursor-pointer"><img class="w-10" src="../../assets/retry.png"></div>
                  </div>
                  <div class="flex flex-col self-center">
                      <div class="text-xs mx-2 font-semibold" style="margin-bottom: 2px;color: #0000ff;">Retry Upload </div>
                      <div class="text-xs mx-2 text-grey-darkest">{{message.payload.file_name}}</div>
                  </div>
                </div>
                <div v-else class="flex flex-row justify-center items-center">
                  <img class="w-5 h-5 mr-1" src="../../assets/attach_document.png">
                  <a @click="getDocument('medical_records', message.payload.id)" target="_blank" class="text-m text-grey-darkest cursor-pointer">
                    {{message.payload.file_name}}
                  </a>
                </div>
              </div>
            </div>
            <div v-else-if="message.intentName === 'incoming_text'" class="text-m text-grey-darkest py-2 pt-3 px-3" v-bind:class="{opaque: !messageStatus(message)}" style="line-height: 22px;">
              {{message.payload.text}}
            </div>
            <div class="flex flex-no-grow h-6 justify-end pb-2 px-3">
              <div class="text-xs text-grey pr-1 self-center">{{message.timestamp ? timeString(message.timestamp) : timeString(message.uniqueId)}}</div>
              <span class="flex self-center" v-if="message.status === 'read'">
                <img src="https://res.cloudinary.com/ekincare/image/upload/v1536866423/talk_with_doc/double_tick_blue.svg" width="15px" height="25px" />
              </span>
              <span class="flex self-center" v-else-if="message.status === 'delivered'">
                <img src="https://res.cloudinary.com/ekincare/image/upload/v1536866451/talk_with_doc/double_tick.svg" width="25px" height="25px"/> 
              </span>
              <span class="flex self-center" v-else-if="isMsgSent(message)">
                <img src="https://res.cloudinary.com/ekincare/image/upload/v1536866423/talk_with_doc/single_tick.svg" width="15px" height="15px"/>
              </span>
              <span class="flex self-center text-red" v-else-if="!isMsgSent(message)">
                <button @click="resendMessage(message)" class="hover:bg-grey-lightest bg-white text-green font-semibold py-2 px-4 rounded">
                  Resend
                </button>
                <button @click="deleteMessage(message)" class="hover:bg-grey-lightest bg-white text-red font-semibold py-2 px-4 rounded">
                  Delete
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isActivePastChat && message.user && message.user.type === 'doctor'" >
        <div class="flex justify-end mb-2">
          <div class="rounded-lg rounded-br-none bg-blue-lightest py-2 pt-3 px-3 shadow-sm" style="max-width: 500px; word-wrap: break-word">
            <lab-test-card v-if="message.intentName === 'recommended_tests'" :data="message.payload"/>
            <drug-prescription-card v-if="message.intentName === 'file_prescription'" :data="message.payload"/>
            <div v-if="message.intentName === 'file_attachment'" class="flex flex-row justify-center items-center " v-bind:class="{opaque: !messageStatus(message)}">
              <img class="w-5 h-5 mr-1" src="../../assets/attach_document.png">
              <a @click="getDocument('medical_records', message.payload.id)" target="_blank"  class="text-m test-grey-darkest cursor-pointer">
                {{message.payload.file_name}}
              </a>
            </div>
            <p v-else-if="message.intentName === 'incoming_text'" class="text-m text-grey-darkest" style="line-height: 22px;">
              {{message.payload.text}}
            </p>
            <div class="text-right text-xs text-grey mt-2">
              {{message.timestamp ? timeString(message.timestamp) : timeString(message.uniqueId)}}
            </div>
          </div>
        </div>
      </div>
      <div v-if="message.user && message.user.type === 'customer'" >
        <div class="flex mb-2">
          <div class="rounded-lg rounded-bl-none py-2 pt-3 px-3 bg-white shadow-sm" style="max-width: 500px; word-wrap: break-word">
            <div class="flex flex-row items-center justify-center" v-if="message.intentName === 'file_customer'">
              <img class="w-5 mr-1" src="../../assets/attach_document.png">
              <a @click="getDocument('medical_records', message.payload.id)" target="_blank" class="text-m text-grey-darkest cursor-pointer self-center">
                {{message.payload.file_name}}
              </a>
            </div>
            <p class="text-m text-grey-darkest" style="line-height: 22px;">
              {{message.payload.text}}
            </p>
            <div class="text-right text-xs text-grey mt-2">
              {{message.timestamp ? timeString(message.timestamp) : timeString(message.uniqueId)}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DrugPrescriptionCard from '@/components/Chat/DrugPrescriptionCard'
import LabTestCard from '@/components/Chat/LabTestCard'
export default {
  props: ['messages', 'isActivePastChat', 'isActiveChat'],
  components: {
    DrugPrescriptionCard,
    LabTestCard
  },
  data () {
    return {
    }
  },
  methods: {
    messageStatus: function (message) {
      if (message.status === null || message.status === undefined) {
        return false
      }
      return true
    },
    getDocument: function (doctype, docid) {
      let type = 'medical_records'
      if (doctype === 'Prescription') {
        type = 'prescriptions'
      }
      this.$http.get(window.API_URL + 'doctors/' + type + '/' + docid + '/download').then(response => {
        if (response.body.status === 200) {
          window.open(response.body.url, '_blank')
        } else {
          alert('Error fetching data')
        }
      }, response => {
      })
    },
    timeString: function (milliTime) {
      let t = new Date(Number(milliTime))
      return t.toLocaleTimeString('en-US', {hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Kolkata'})
    },
    isMsgSent: function (message) {
      if (message.status === null || message.status === undefined) {
        return false
      } else if (message.status === 'sent') {
        return true
      }
    },
    dashoffset: function (percent) {
      var circle = document.querySelector('circle')
      if (!circle) return
      var radius = circle.r.baseVal.value
      var circumference = radius * 2 * Math.PI
      return circumference - percent / 100 * circumference
    },
    dasharray: function () {
      var circle = document.querySelector('circle')
      if (!circle) return
      var radius = circle.r.baseVal.value
      var circumference = radius * 2 * Math.PI
      return `${circumference} ${circumference}`
    },
    resendMessage: function (message) {
      this.$store.dispatch('message/resendMessage', message)
    },
    deleteMessage: function (message) {
      this.$store.dispatch('message/deleteMessage', message)
    }
  }
}

</script>

<style>
.opaque {
  opacity: 0.5;
}
.progress-ring-circle
{       
  transition: 0.35s stroke-dashoffset;
  /* axis compensation */
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Chat/ChatMessageContainer.vue